module.exports = __webpack_public_path__ + "img/prioritas_cod_dg.6cefff92.png";